
import PageContent from "../components/pageContent";
import TopBarWithBreadCrumb from "../components/TopBarWithBreadCrumb";
import { useTranslation } from "react-i18next";
import logo from "../assets/Telurmix2.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { checkCrud } from "../helpers/userRolesHelper";
import { useHistory } from "react-router-dom";
import { apiGetCurrentUser } from "../services/UsersService";
import { userLoginAction } from "../redux/actions";

interface Props {
  contextLevel: string;
}

const MainPageLoadingNeededConfiguration = (props: Props) => {
  const { t } = useTranslation(undefined);

  const userInfo = useSelector((state: any) => state.userInfo);
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {

    apiGetCurrentUser()
      .then((responseData) => {
        dispatch(userLoginAction(JSON.stringify(responseData.data)));

        if (responseData.data.Anonymous) {
          history.push("/login");
        }
        else {

          var canToning = checkCrud('toning', 'read', responseData.data);

          if (canToning) {
            history.push("/tonovani");
          }
          else {
            history.push("/noaccess");
          }

        }
      })
      .catch(() => {
        if (window.location.href.indexOf("login") <= 0) {
          window.location.href = "/login";
        }
      });
  }, [])

  return (
    <>
      <TopBarWithBreadCrumb
        contextLevel={props.contextLevel}
        pageLevel={t('Label')}
      />
      <PageContent>
        <>
          <div style={{ textAlign: 'center' }}>
            <a href="#!" className="logo-wrapper waves-effect">
              <img style={{ paddingTop: 0, paddingBottom: 0 }} src={logo} />
            </a>

            <h3 style={{ textAlign: 'center' }}>{t('LoadingApplication')}</h3>
          </div>
        </>
      </PageContent >
    </>
  );
};

export default MainPageLoadingNeededConfiguration;
